<template>
    <PromoContent v-if="contentIsInViewport" />
</template>
<script setup lang="ts">
import { computed, nextTick, ref, watch } from "vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { eventBus, GlobalEvents } from "@sazka/utils/global-events";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import PromoContent from "./_promo-content.vue";

const contentIsInViewport = ref(false);

const wrapperElem = document.getElementById("random-recommendation-card-wrapper");
const cardElem = document.getElementById("random-recommendation-card");

const isMobile = computed(() => !useBreakpoints("xs2").value);
const ticketFilterIsActive = ref(false);
const showWidget = computed(() => !isMobile.value || !ticketFilterIsActive.value);

eventBus.on(GlobalEvents.TicketFilterActive, () => {
    ticketFilterIsActive.value = true;
});

eventBus.on(GlobalEvents.TicketFilterInactive, () => {
    ticketFilterIsActive.value = false;
});

watch(showWidget, (shouldBeVisible) => {
    if (!cardElem) return;

    if (shouldBeVisible) {
        cardElem.classList.remove("d-none");
    } else {
        cardElem.classList.add("d-none");
    }
});

const initSlider = () => {
    if (!wrapperElem) {
        contentIsInViewport.value = true;
        return;
    }

    nextTick(() => {
        onViewportEnter(wrapperElem, 0).then(() => {
            contentIsInViewport.value = true;
        });
    });
};

initSlider();
</script>
